import { createContext, useState, ReactNode, useEffect, useContext } from 'react'

import { AuthContext } from './auth.context'
import { isSuiteSsoRedirectMode } from '../sso/sso-flags'
import { UserSessionType } from '../types/user.types'
import { UserContextType } from '../types/context.types'

export const UserContext = createContext<Partial<UserContextType>>({})

export const userSessionInitialState = {
  firstName: ''
}

const Provider = ({ children }: { children: ReactNode }) => {
  const { isAuth } = useContext(AuthContext)
  // const [userSession, setUserSession] = useState<UserSessionType | null>(() => {
  //   if (typeof window !== 'undefined') {
  //     const storedUserSession = window.sessionStorage.getItem('userSession') || window.localStorage.getItem('userSession')
  //     return storedUserSession ? JSON.parse(storedUserSession) : { ...userSessionInitialState }
  //   }
  //   return { ...userSessionInitialState }
  // })
  const [userSession, setUserSession] = useState<UserSessionType | null>(null)

  useEffect(() => {
    if (isSuiteSsoRedirectMode()) {
      return
    }

    const init = async () => {
      const payload = isAuth?.replaceAll('"', '').split('.')[1]

      if (!payload) return

      const decoded = JSON.parse(atob(payload))
      setUserSession(decoded.user_data)
    }

    if (isAuth) {
      init()
    }
  }, [isAuth])

  const value: UserContextType = {
    userSession: userSession as UserSessionType,
    setUserSessionData: (systemUserData?: UserSessionType | null) => {
      if (!systemUserData) {
        setUserSession(null)
        if (typeof window !== 'undefined' && window.sessionStorage.getItem('userSession')) {
          window.sessionStorage.removeItem('userSession')
        }
        if (typeof window !== 'undefined' && window.localStorage.getItem('userSession')) {
          window.localStorage.removeItem('userSession')
        }
        return
      }

      setUserSession(systemUserData)

      // if (
      //   typeof window !== 'undefined' &&
      //   (!systemUserData.subRole ||
      //     (systemUserData.subRole && systemUserData.subRole !== 'compliance-specialist') ||
      //     (systemUserData.subRole && systemUserData.subRole === 'compliance-specialist' && systemUserData.role !== 'super-admin'))
      // ) {
      //   window.sessionStorage.setItem('userSession', JSON.stringify(systemUserData))
      // }
      // if (typeof window !== 'undefined' && systemUserData.subRole && systemUserData.subRole === 'compliance-specialist' && systemUserData.role === 'super-admin') {
      //   window.localStorage.setItem('userSession', JSON.stringify(systemUserData))
      // }
    }
  }

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}

const UserContextProvider = {
  Provider,
  Consumer: UserContext.Consumer
}

export default UserContextProvider
